import { VisibleEnum, BrandsEnum } from 'types';
import * as yup from 'yup';

export const initialFormState = {
  titleAm: '',
  descriptionAm: '',
  titleEn: '',
  titleRu: '',
  descriptionEn: '',
  descriptionRu: '',
  images: {} as FileList,
  visible: VisibleEnum.YES,
}

const imageListSchema = yup.mixed()
  .test(
    'is-files-length',
    'Upload image is required',
    (value) => Object.keys(value || {}).length !== 0
  )
  .test(
    'is-files-length',
    'You can upload maximum 5 pictures',
    (value) => Object.keys(value || {}).length <= 5
  )

export const createProductSchema = yup.object().shape({
  titleAm: yup.string().required('Title is required.'),
  titleEn: yup.string().required('Title is required.'),
  titleRu: yup.string().required('Title is required.'),
  images: imageListSchema,
  visible: yup.string().required(),
  brand: yup.string().required('Brand is required.'),
  descriptionAm: yup.string().optional().max(250, 'Description must be 250 characters or fewer.'),
  descriptionEn: yup.string().optional().max(250, 'Description must be 250 characters or fewer.'),
  descriptionRu: yup.string().optional().max(250, 'Description must be 250 characters or fewer.'),
});
